import { createFileRoute } from '@tanstack/react-router';
import { requireWorkstation } from '../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../pages/Loading/Loading';

const ReprintTagsTracking = lazy(() => import('../../../../pages/ReprintTagsTracking/ReprintTagsTracking'));

export const Route = createFileRoute('/$lang/_authenticated/reprint-tags-tracking')({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <ReprintTagsTracking />
    </Suspense>
  ),
});
